<template>
    <div class="container">
        <div class="main">
            <div class="step-wrap">
                <el-steps :active="active" align-center class="custom">
                    <el-step title="账户信息"></el-step>
                    <el-step title="公司信息"></el-step>
                    <el-step title="法人信息"></el-step>
                    <el-step title="财务信息"></el-step>
                </el-steps>
            </div>
            <div class="step-main">
                <div class="basics-section">
                    <div class="basics-section-main">
                        <div class="head">
                            <span class="head-1" v-show="active===0">账户信息</span>
                            <span class="head-1" v-show="active===1">公司信息</span>
                            <span class="head-1" v-show="active===2">法人信息</span>
                            <span class="head-1" v-show="active===3">财务信息</span>
                            <span class="head-2" v-show="active===0">Basic Information</span>
                            <span class="head-2" v-show="active===1">Company Information</span>
                            <span class="head-2" v-show="active===2">Legal person information</span>
                            <span class="head-2" v-show="active===3">Financial Information</span>
                        </div>
                        <div class="cont">

                            <el-form ref="informationForm" :model="information" label-width="180px" size="big"
                                     :rules="informationRules"
                                     class="information-wrap">
                                <div v-show="active===0">
                                    <el-form-item label="Account" prop="account">
                                        <el-input v-model="information.account"></el-input>
                                    </el-form-item>
                                    <el-form-item label="Password" prop="password">
                                        <el-input v-model="information.password"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="email" label="Email">
                                        <el-input v-model="information.email"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="mobile" label="Mobile">
                                        <el-input v-model="information.mobile"></el-input>
                                    </el-form-item>
                                </div>
                                <div v-show="active===1">

                                    <el-form-item prop="companyName" label="Company Name">
                                        <el-input v-model="information.companyName"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="storeName" label="Store Name">
                                        <el-input v-model="information.storeName"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="enterpriseCode" label="Enterprise Code">
                                        <el-input v-model="information.enterpriseCode"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="address" label="Address">
                                        <el-input v-model="information.address"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="account" label="Business License">
                                        <el-upload
                                                class="avatar-uploader"
                                                action="/student/shop/uploader"
                                                :show-file-list="false"
                                                :on-success="function(res,file){return handleAvatarSuccess(res,file,'businessLicense')}"
                                                :before-upload="beforeAvatarUpload">
                                            <img v-if="information.businessLicense" :src="information.businessLicense"
                                                 class="avatar">
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                    </el-form-item>
                                </div>
                                <div v-show="active===2">
                                    <el-form-item prop="legalName" label="Legal Name">
                                        <el-input v-model="information.legalName"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="idCard" label="ID Card">
                                        <el-input v-model="information.idCard"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="idCardPositive" label="ID Card(Positive)">
                                        <el-upload
                                                class="avatar-uploader"
                                                action="/student/shop/uploader"
                                                :show-file-list="false"
                                                :on-success="function(res,file){return handleAvatarSuccess(res,file,'idCardPositive')}"
                                                :before-upload="beforeAvatarUpload">
                                            <img v-if="information.idCardPositive" :src="information.idCardPositive"
                                                 class="avatar" style="object-fit: contain">
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                    </el-form-item>
                                    <el-form-item prop="idCardNegative" label="ID Card(Negative)">
                                        <el-upload
                                                class="avatar-uploader"
                                                action="/student/shop/uploader"
                                                :show-file-list="false"
                                                :on-success="function(res,file){return handleAvatarSuccess(res,file,'idCardNegative')}"
                                                :before-upload="beforeAvatarUpload">
                                            <img v-if="information.idCardNegative" :src="information.idCardNegative"
                                                 class="avatar" style="object-fit: contain">
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                    </el-form-item>
                                    <el-form-item prop="birthday" label="Date Of Birth">
                                        <el-date-picker
                                                v-model="information.birthday"
                                                type="date"
                                                placeholder="选择日期">
                                        </el-date-picker>
                                    </el-form-item>
                                    <el-form-item prop="taxType" label="Tax Type">
                                        <el-select v-model="information.taxType" placeholder="请选择">
                                            <el-option
                                                    v-for="item in ['VAT','EIN']"
                                                    :key="item"
                                                    :label="item"
                                                    :value="item">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item prop="taxNumber" label="Tax Number">
                                        <el-input v-model="information.taxNumber"></el-input>
                                    </el-form-item>
                                </div>
                                <div v-show="active===3">
                                    <el-form-item prop="bank" label="Bank">
                                        <el-input v-model="information.bank"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="openBank" label="Open Bank">
                                        <el-input v-model="information.openBank"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="accountNo" label="Account No.">
                                        <el-input v-model="information.accountNo"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="cardHolder" label="Card Holder">
                                        <el-input v-model="information.cardHolder"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="validityYear" label="validity Year">
                                        <el-select v-model="information.validityYear" placeholder="选择有效期年"
                                                   style="width: 220px">
                                            <el-option
                                                    v-for="item in yearList"
                                                    :key="item"
                                                    :label="item"
                                                    :value="item">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item prop="validityMonth" label="valid Month">
                                        <el-select v-model="information.validityMonth" placeholder="选择有效期月"
                                                   style="width: 220px">
                                            <el-option
                                                    v-for="item in 12"
                                                    :key="item"
                                                    :label="item"
                                                    :value="item">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </el-form>


                        </div>
                        <div class="main-footer">
                            <div class="btnn active" @click="active--" v-if="active>0">
                                上一步
                            </div>
                            <div class="btnn active" @click="active++" v-if="active<3">
                                下一步
                            </div>
                            <div class="btnn active" @click="create" v-if="active===3">
                                创建店铺
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="foot">
            闽ICP备17025076号-2 <span style="margin: 0 20px"></span>©2017-{{new Date().getFullYear()}} All rights reserved.
        </div>
    </div>
</template>

<script>
    export default {
        name: "shopSetting",
        data() {
            return {
                active: 0,
                information: {
                    "id": "",
                    "account": "",
                    "password": "",
                    "confirmPassword": "",
                    "email": "",
                    "mobile": "",
                    "companyName": "",
                    "storeName": "",
                    "enterpriseCode": "",
                    "address": "",
                    "businessLicense": "",
                    "legalName": "",
                    "idCard": "",
                    "idCardPositive": "",
                    "idCardNegative": "",
                    "birthday": "",
                    "taxType": "",
                    "taxNumber": "",
                    "bank": "",
                    "openBank": "",
                    "accountNo": "",
                    "cardHolder": "",
                    "validityYear": "",
                    "validityMonth": "",
                    "status": "",
                    "holiday": ""
                },
                informationRules: {
                    "account": [
                        {required: true, message: '请输入账号', trigger: 'blur'},
                    ],
                    "password": [
                        {required: true, message: '请输入账号密码', trigger: 'blur'},
                    ],
                    "email": [
                        {required: true, message: '请输入邮箱地址', trigger: 'blur'},
                        // {required: true, message: '请输入正确的邮箱地址', trigger: 'blur', type: 'email'},
                    ],
                    "mobile": [
                        {required: true, message: '请输入手机号码', trigger: 'blur'},
                    ],
                    "companyName": [
                        {required: true, message: '请输入公司名称', trigger: 'blur'},
                    ],
                    "storeName": [
                        {required: true, message: '请输入店铺名称', trigger: 'blur'},
                    ],
                    "enterpriseCode": [
                        {required: true, message: '请输入营业执照号', trigger: 'blur'},
                    ],
                    "address": [
                        {required: true, message: '请输入经营地址', trigger: 'blur'},
                    ],
                    "businessLicense": [
                        {required: true, message: '请上传营业执照扫描件', trigger: 'blur'},
                    ],
                    "legalName": [
                        {required: true, message: '请输入法人信息', trigger: 'blur'},
                    ],
                    "idCard": [
                        {required: true, message: '请输入法人身份证号', trigger: 'blur'},
                    ],
                    "idCardNegative": [
                        {required: true, message: '请上传身份证（正面）', trigger: 'blur'},
                    ],
                    "idCardPositive": [
                        {required: true, message: '请上传身份证（背面）', trigger: 'blur'},
                    ],
                    "birthday": [
                        {required: true, message: '请输入生日', trigger: 'blur'},
                    ],
                    "taxType": [
                        {required: true, message: '请选择税务类型', trigger: 'blur'},
                    ],
                    "taxNumber": [
                        {required: true, message: '请输入税号', trigger: 'blur'},
                    ],
                    "bank": [
                        {required: true, message: '请输入公司开户银行名称（例如：中国银行）', trigger: 'blur'},
                    ],
                    "openBank": [
                        {required: true, message: '请输入公司开户银行名称（例如：中国银行北京市分行）', trigger: 'blur'},
                    ],
                    "accountNo": [
                        {required: true, message: '请输入公司银行卡号', trigger: 'blur'},
                    ],
                    "cardHolder": [
                        {required: true, message: '请输入持卡人姓名', trigger: 'blur'},
                    ],
                    "validityYear": [
                        {required: true, message: '请选择银行卡有效期-年', trigger: 'blur'},
                    ],
                    "validityMonth": [
                        {required: true, message: '请选择银行卡有效期-月', trigger: 'blur'},
                    ],
                    "holiday": ""
                },
                imageUrl: ''
            }
        },
        computed:{
            yearList(){
                let arr = []
                let i = 0
                while(i<40){
                    arr.push(2000+i);
                    i++
                }
                return arr
            }
        },
        created() {
            this.axios.post('/login/current').then(res => {
                if (res.login && res.succeed) {
                    this.$store.commit('setData', {dataKey: 'user', value: res.user})
                }
            })
            this.axios.post('/student/shop/get').then(res => {
                if (res.succeed && res.login) {
                    Object.assign(this.information,res.shop)
                    this.information.id = res.shop.id
                }
            })
        },
        methods: {
            handleAvatarSuccess(res, file, name) {
                if (res.succeed && res.login) {
                    this.information[name] = res.path
                }
            },
            beforeAvatarUpload() {

            },
            create() {
                this.$refs['informationForm'].validate((valid) => {
                    if (valid) {
                        let $information = JSON.parse(JSON.stringify(this.information))
                        $information.birthday = new Date($information.birthday).$Format('yyyy-MM-dd')
                        this.axios.post('/student/shop/submit', $information).then(res => {
                            if (res.succeed && res.login) {
                                this.$message.success('创建成功！')
                                this.$router.push('/MaritimeSilkRoad/selection')
                            }
                        })
                    } else {
                        this.$message.error('店铺信息未全部填写，请检查后重试')
                        return false;
                    }
                });
            }
        }
    }
</script>

<style scoped lang="scss">

    .table-row-handle {
        display: flex;

        span {
            padding: 6px 12px;
            background: #F44336;
            margin-right: 6px;
            margin-bottom: 6px;
            border-radius: 8px;
            color: #ffffff;
            cursor: pointer;
            word-break: keep-all;

            &.cancel {
                background: #FDAD53;
            }

            &.set {
                background: #4149A9;
            }
        }
    }

    .main {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 30px;

        .step-wrap {
            width: 740px;
            margin-bottom: 28px;
            padding: 10px 0 0 0;
            border-radius: 10px;

            ::v-deep .el-steps.custom {
                div.el-step__head.is-finish {
                    color: #4149A9;
                    border-color: #FFFFFF;

                    .el-step__icon {
                        width: 28px;
                        height: 28px;
                        background: #FFFFFF;

                    }

                    .el-step__icon.is-text {
                        border: none;
                    }

                    .el-step__line {
                        background-color: #FFFFFF;
                    }
                }

                div.el-step__title.is-finish {
                    color: #FFFFFF;
                    font-weight: normal;
                }

                div.el-step__head.is-process {
                    color: #FFFFFF;
                    border-color: #7981C3;

                    .el-step__icon {
                        width: 28px;
                        height: 28px;
                        background: #FF9800;

                    }

                    .el-step__icon.is-text {
                        border: none;
                    }

                    .el-step__line {
                        background-color: #7981C3;
                    }
                }

                div.el-step__title.is-process {
                    color: #ff8700;
                    font-weight: normal;
                }

                div.el-step__head.is-wait {
                    color: #4149A9;
                    border-color: #7981C3;

                    .el-step__icon {
                        width: 28px;
                        height: 28px;
                        background: #7981C3;

                    }

                    .el-step__icon.is-text {
                        border: none;
                    }

                    .el-step__line {
                        background-color: #7981C3;
                    }
                }

                div.el-step__title.is-wait {
                    color: #7981C3;
                    font-weight: normal;
                }
            }

            /*::v-deep .el-step__title.is-wait {*/
            /*    color: #7981C3;*/
            /*}*/
            /*::v-deep .el-step__icon.is-text {*/
            /*    border: none;*/
            /*}*/
            /*::v-deep .el-step__icon {*/
            /*    width: 28px;*/
            /*    height: 28px;*/
            /*}*/
            /*::v-deep .el-step__title {*/
            /*    font-size: 14px;*/
            /*}*/
            /*::v-deep .el-step__head.is-finish {*/
            /*    color: #4149A9;*/
            /*    border-color: #fFFFFF;*/
            /*}*/
            /*::v-deep .el-step__title.is-finish{*/
            /*    color: #FFFFFF;*/
            /*}*/
            /*::v-deep .el-step__title.is-process{*/
            /*    color: #FF9800;*/
            /*}*/
            /*::v-deep .is-process {*/
            /*    color: #FF9800;*/
            /*    .el-step__icon {*/
            /*        background: #FF9800;*/
            /*        color: #fFFFFF;*/
            /*    }*/
            /*}*/
        }

        .step-main {
            width: 1200px;

            .cont {
                display: flex;
                justify-content: center;
                margin-bottom: 20px;

                .information-wrap {
                    width: 600px;

                    ::v-deep .avatar-uploader .el-upload {
                        border: 1px dashed #d9d9d9;
                        border-radius: 6px;
                        cursor: pointer;
                        position: relative;
                        overflow: hidden;
                    }

                    ::v-deep .avatar-uploader .el-upload:hover {
                        border-color: #409EFF;
                    }

                    ::v-deep .avatar-uploader-icon {
                        font-size: 28px;
                        color: #8c939d;
                        width: 178px;
                        height: 178px;
                        line-height: 178px;
                        text-align: center;
                    }

                    ::v-deep .avatar {
                        width: 178px;
                        height: 178px;
                        display: block;
                    }
                }
            }

            div.main-footer {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
                margin-top: 30px;

                > div.btnn {
                    box-shadow: 0px 10px 26px -10px #9E9E9E;
                    cursor: pointer;
                    background: #FF65A5;
                    width: 160px;
                    text-align: center;
                    padding: 12px;
                    color: #FFFFFF;
                    transition: all 0.3s linear;

                    &:first-child {
                        border-top-left-radius: 10px;
                        border-bottom-left-radius: 10px;
                        background: #ABD5DB;
                    }

                    &:last-child {
                        border-top-right-radius: 10px;
                        border-bottom-right-radius: 10px;
                        /*border-radius: 0 10px 10px 0;*/
                        background: #4149A9;
                    }

                    &:hover {
                        transition: all 0.3s ease-in-out;
                        box-shadow: 0px 10px 26px -10px #000;
                    }
                }
            }
        }
    }

    .pagination-wrap {
        margin-top: 30px;
        display: inline-block;

        > div.pagination {
            padding: 0 20px;
            height: 60px;
            background: #FFFFFF;
            border-radius: 10px;
            box-shadow: 3px 10px 20px -6px #b5cdd3;
            display: flex;
            align-items: center;
            margin-bottom: 20px;
        }
    }

    div.foot {
        width: 100%;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 30px;
        font-size: 14px;
        color: #ABD5DB;
    }

    .set-promotion-dialog {
        .main {
            display: flex;
            justify-content: center;
            padding-bottom: 50px;

            > div.main-item {
                display: flex;
                flex-direction: column;
                font-size: 16px;
                font-weight: bolder;
                align-items: center;
                margin-right: 32px;

                > div {
                    &:first-child {
                        margin-bottom: 10px;
                    }

                    &:last-child {
                        padding: 15px 58px;
                        background: #089bab;
                        color: #FFFFFF;
                        border-radius: 10px;

                        input {
                            width: 130px;
                            border: 1px dashed #ff9800;
                            height: 48px;
                            line-height: 48px;
                            border-radius: 10px;
                            outline: none;
                            padding: 0 10px;
                            box-sizing: border-box;
                            font-weight: bolder;
                            text-align: center;
                        }
                    }
                }
            }

            div.cancle-wrap {
                display: flex;
                align-items: center;

                div.cancle-wrap-item {
                    border: 1px dashed #adadad;
                    padding: 36px;
                    border-radius: 10px;
                    /*transition: all 0.3s linear;*/
                    cursor: pointer;

                    &:first-child {
                        margin-right: 30px;
                    }

                    &:hover, &.active {
                        background: rgba(255, 152, 0, 0.21);
                        /*transition: all 0.3s linear;*/
                    }

                    .item-box {
                        border-radius: 20px;
                        background: #FDAD53;
                        color: #FFFFFF;
                        padding: 10px 20px;

                        i {
                            padding: 0 30px;
                        }
                    }
                }
            }
        }

        .footer {
            display: flex;
            justify-content: center;
            align-items: center;
            padding-bottom: 30px;
        }
    }
</style>
